import { useCallback } from "react";
import {
  type BiReporter,
  type DesignerModalBiEvent,
  DesignerBIEventTypes,
} from "@wix/picasso-common";
import { useBiLogger } from "../../../bi/useBiLogger";
import { PAGE_NAME } from "../../../bi/constants";

export const useDesignerModalBiReporter = (): BiReporter => {
  const bi = useBiLogger();

  return useCallback<BiReporter>(
    (event: DesignerModalBiEvent) => {
      if (event.type === DesignerBIEventTypes.MODAL_CLICK) {
        bi.trackUserClickPicasso({
          pageName: PAGE_NAME.HOME_PAGE,
          pageArea: event.pageArea,
          buttonName: event.buttonName,
          value: event.value,
          lastValue: event.lastValue,
          additionalInfo: event.additionalInfo,
        });
      } else if (event.type === DesignerBIEventTypes.MODAL_VIEW) {
        bi.handleGenericModalView({
          backgroundPageName: PAGE_NAME.HOME_PAGE,
          modalName: event.modalName,
          additionalInfo: event.additionalInfo,
        });
      }
    },
    [bi],
  );
};
